import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request that must not raise the global "please wait" overlay, for
 * background work the user did not explicitly ask to wait for.
 */
export const SKIP_LOADING_OVERLAY = new HttpContextToken<boolean>(() => false);

export function skipLoadingOverlay(): HttpContext {
  return new HttpContext().set(SKIP_LOADING_OVERLAY, true);
}
